module.exports = __webpack_public_path__ + "img/mod_2.74688fe6.png";